import { useState } from 'react';
import { Column } from 'devextreme-react/data-grid';
import { useGetBackOrdered } from "../api/get-backordered";
import {
    LoadPagePanel,
    LoadPopupPanel,
    SyncDataGrid
} from '../../../../components';
import Popup, { ToolbarItem } from 'devextreme-react/popup';
import { useGetBackOrderedOrders } from '../api/get-backordered-orders';
import BackOrderedOrdersGrid from './BackOrderedOrdersGrid';

export default function BackOrderedGrid() {

    const backOrdered = useGetBackOrdered();
    const [popupState, setPopupState] = useState<{ visible: boolean, productID: number, distributorID: number }>(
        { visible: false, productID: 0, distributorID: 0 });

    const backOrderedOrders = useGetBackOrderedOrders(popupState.productID, popupState.distributorID, popupState.visible);

    return (
        <>
            <SyncDataGrid
                stateStorageKey='back-ordered-grid'
                className={'dx-card wide-card'}
                dataSource={backOrdered.data}
                keyExpr={['productID', 'distributorID']}
            >
                <Column
                    dataField={'itemDescription'}
                    caption={'Description'}
                    dataType="string"
                />
                <Column
                    dataField={'productLine'}
                    caption={'Product Line'}
                    dataType="string"
                />
                <Column
                    dataField={'sku'}
                    caption={'SKU'}
                    dataType="string"
                />
                <Column
                    dataField={'distributor'}
                    caption={'Distributor'}
                    dataType="string"
                />
                <Column
                    dataField={'lastOrderDate'}
                    caption={'Last Order Date'}
                    dataType="date"
                />
                <Column
                    dataField={'estimatedDeliveryDate'}
                    caption={'Estimated Delivery Date'}
                    dataType="date"
                />
                <Column
                    dataField={'orderCount'}
                    caption={'Orders'}
                    dataType="number"
                    alignment={"center"}
                    cellRender={(cell) => {
                        return <a onClick={() => {
                            setPopupState({
                                visible: true,
                                productID: cell.data.productID,
                                distributorID: cell.data.distributorID
                            });
                        }}>{cell.data.orderCount}</a>
                    }}
                />
            </SyncDataGrid>

            <Popup
                title="Material Orders"
                visible={popupState?.visible}
                hideOnOutsideClick={true}
                onHiding={() => setPopupState({
                    ...popupState,
                    visible: false
                })}
            >
                <ToolbarItem
                    options={{
                        icon: 'dx-icon dx-icon-close',
                        onClick: () => setPopupState({
                            ...popupState,
                            visible: false
                        })
                    }}
                    widget="dxButton"
                    location="after"
                />

                <BackOrderedOrdersGrid records={!backOrderedOrders.isLoading ? backOrderedOrders.data : []} />

                <LoadPopupPanel visible={backOrderedOrders.isLoading}></LoadPopupPanel>
            </Popup>

            <LoadPagePanel visible={backOrdered.isLoading} />
        </>
    )
} 
